import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Register } from '@xanadu/core';
import { InputSubscriberComponent } from '../base/input-subscriber.component';


@Component({
    selector: 'app-meta',
    templateUrl: './meta.component.html',
    styleUrls: ['./meta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('meta')
export class MetaComponent extends InputSubscriberComponent {
    public dataMeta: any = { id: 'meta', name: 'Meta data', info: 'JSON meta data', rows: 36, textStyle: '{"font-family":"monospace"}' };
}
